import struct from '@nichoth/observ/struct'
import Model from '@nichoth/observ/model'

function ReadOnlyModel ({ io, parse = {} }) {
    return Model({
        io,
        state: {
            data: struct({})
        },
        update: {
            get: function (state, res) {
                state.hasFetched.set(true)
                state.data.set(parse.get ? parse.get(res) : res.result)
            }
        }
    })
}

export default ReadOnlyModel
